import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useQuery } from "react-query";
import LoadingApiQuery from "../../../components/LoadingApiQuery";
import axiosClient from "../../../lib/axios";
import { useMemo, useState } from "react";
import { formatarTelefone } from "../../../helpers/masks";
import { desformatarTelefone } from "../../../helpers/unmask";
import EditIcon from '@mui/icons-material/Edit';
import truncarString from "../../../helpers/truncarString";
import DialogCriacaoEditIntegracaoWhatsapp from "./DialogCriacaoEdit";
import DisplayNotFoundInfo from "../../../components/DisplayNotFindInfo";

export default function IntegracaoWhatsapp() {

    const [openDialogEditar, setOpenDialogEditar] = useState<TConfigWhatsApp | null>(null)

    //Querys e Mutations
    const { data, isLoading: isLoadingConfiguracoes } = useQuery({
        queryKey: ["configuracoes-whatsapp"],
        queryFn: () => axiosClient.get("/configuracoes", {
            params: {
                chave: 'config_whatsapp'
            }
        })
    });

    const dataConfigWhatsapp: TConfigWhatsApp | null = useMemo(() => {
        // Se não vier nada retorna null;
        if (!data?.data) return null;

        // Verificação se possui os campos numero e token
        const isValid = Object.values(data.data).every(
            (item: any) => "numero" in item && "token" in item
        );


        // Se for valido retorna o data
        return isValid ? data.data : null;
    }, [data]);


    return (
        <>
            <Typography mb={3} variant="h6">Integração WhatsApp</Typography>
            {
                isLoadingConfiguracoes &&
                <LoadingApiQuery />
            }
            {
                (!isLoadingConfiguracoes && !dataConfigWhatsapp) &&
                <DisplayNotFoundInfo label="Nenhuma integração encontrada" />
            }

            {(!isLoadingConfiguracoes && dataConfigWhatsapp) && (
                <>
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell><b>Nome</b></TableCell>
                                    <TableCell ><b>Número</b></TableCell>
                                    <TableCell ><b>Token</b></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    Object.entries(dataConfigWhatsapp as TConfigWhatsApp).map(([chave, valores]) => {
                                        const titulo = chave.replace(/_/g, " ").replace(/\b\w/g, letra => letra.toUpperCase());

                                        const valor: TConfigWhatsApp = {
                                            [chave]: {
                                                numero: desformatarTelefone(valores.numero),
                                                token: valores.token
                                            }
                                        };

                                        return (
                                            <TableRow
                                                key={chave}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell>
                                                    {titulo}
                                                </TableCell>
                                                <TableCell>
                                                    {valores.numero === "" ? "-" : formatarTelefone(valores.numero)}
                                                </TableCell>
                                                <TableCell>
                                                    {valores.token === "" ? "-" : truncarString(valores.token)}
                                                </TableCell>
                                                <TableCell>
                                                    <Box display="flex" alignItems="center" justifyContent="flex-end">
                                                        <IconButton aria-label="edit" onClick={() => setOpenDialogEditar(valor)}>
                                                            <EditIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {
                        Boolean(openDialogEditar) &&
                        <DialogCriacaoEditIntegracaoWhatsapp
                            open={Boolean(openDialogEditar)}
                            handleClose={() => setOpenDialogEditar(null)}
                            defaultValue={openDialogEditar}
                        />
                    }
                </>
            )}

        </>
    )
}

export type TConfigWhatsApp = {
    [key: string]: {
        numero: string
        token: string
    }
}

export type TFormEnvioConfigWhatsApp = {
    chave: string;
    valor: TConfigWhatsApp
}
